import React, { useEffect, useState } from "react";

import Swal from "sweetalert2";
import * as Yup from "yup";
import { Container, Label, Input, FormGroup, Col } from "reactstrap";
import { useNavigate } from "react-router-dom";
// import { Loading } from "../../share/loading";
import "../../share/form.css";

export const MoveSupportIdComponent = () => {

    const navigate = useNavigate();
    const user = JSON.parse(localStorage.getItem("userData"));
    const [deptId, setDeptId] = useState("");
    const [moveDeptId, setMoveDeptId] = useState("");

    useEffect(() => {
        async function GetVMdDept() {
            try {
                const responseDept = await fetch("/api/MasterData/getVMdDept")
                const data = await responseDept.json()
                setDeptId(data.dataenum.map((item) => ({
                    value: item.deptId,
                    label: item.site
                })))
                setMoveDeptId(data.dataenum.map((item) => ({
                    value: item.deptId,
                    label: item.site
                })))
            } catch (e) {
                console.log(e)
            }
        }
        GetVMdDept();
    }, []);


    return (
        <Container className="d-flex justify-content-center mb-5">
            <div className="d-flex flex-column form-border">
                <div className="px-5 mt-5 d-flex justify-content-evenly">
                    <FormGroup
                        row
                        className="pt-3" >
                        <Label
                            for="test_license_no">
                            เลขที่อ้างอิง
                            <span
                                className="require-input">
                                *
                            </span>

                        </Label>

                        <br />
                        <Col className="d-flex">
                            <Input
                                className=""
                                type="text"
                                name="licenseTestName"
                            />
                            <button
                                type="button"
                                // disabled={startDate < new Date() && new Date() < endDate ? true:false}
                                className="btn border border-1   w-25 text-center input-color"
                            // onClick={() => {
                            //     CheckCertificateNo() // ขอ data
                            // }}
                            >
                                ค้นหา
                            </button>
                        </Col>

                    </FormGroup>
                </div>
                <div className="px-5 d-flex justify-content-evenly align-items-center">
                    <FormGroup
                        row
                        className="pt-3" >
                        <Label
                            for="test_license_no">
                            หน่วยงานเดิม

                        </Label>

                        <br />
                        <Col className="d-flex">
                            <Input
                                className=""
                                type="text"
                                name="licenseTestName"
                            />

                        </Col>

                    </FormGroup>
                    <span>{"-->"}</span>
                    <FormGroup
                        row
                        className="pt-3" >
                        <Label
                            for="test_license_no">
                            หน่วยงานใหม่


                        </Label>

                        <br />
                        <Col className="d-flex">
                            <Input
                                className=""
                                type="text"
                                name="licenseTestName"
                            />

                        </Col>

                    </FormGroup>
                </div>

                <div className="d-flex justify-content-evenly text-center w-100">
                    <form className="d-flex justify-content-evenly text-center w-100">
                        <button className="btn-green rounded-pill w-25 my-5" type="submit">
                            บันทึก
                        </button>

                    </form>
                </div>
            </div>
        </Container>

    )
}
